import { PlannerBase }   from "../../planner_base";
import { Global, CellPosition, LineSelectedSchedule, LineSelectedTask }  from "../model";
import watch from "redux-watch";
import isEqual from 'is-equal';
export class TaskEditorBase extends PlannerBase {
  selected: boolean = false;
  init(){
    super.init();
    this.watch();
    this.watchPlannerData('selectedTask', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeSelectedTask(newVal, oldVal, objectPath)});
  }
  onChangeSelectedTask(selectedTask: LineSelectedTask, oldVal, objectPath) {
    this.onSelectedTask(selectedTask);
  }
  isMyTask(selectedTask: LineSelectedTask){
    return selectedTask.lineId == this.opts.id
  }
  onSelectedTask(selectedTask: LineSelectedTask){
    if(selectedTask == null || !this.isMyTask(selectedTask)){
      this.unSelect(selectedTask);
    } else {
      this.select(selectedTask);
    }
  }
  unSelect(selectedTask: LineSelectedTask){
    if(!this.selected){ return; }
    this.beforeUnselect(selectedTask);
    this.selected = false;
    this.update();
  }
  select(selectedTask: LineSelectedTask){
    this.beforeSelect(selectedTask);
    this.selected = true;
    this.update();
  }
  beforeUnselect(selectedTask: LineSelectedTask){

  }
  beforeSelect(selectedTask: LineSelectedTask){

  }
}
